import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TikTokBusinessService } from '../../services/tiktok-business/tiktok-business.service';

@Component({
  selector: 'app-tiktok-business-callback',
  templateUrl: './tiktok-business-callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class TikTokBusinessCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private tiktokBusinessService = inject(TikTokBusinessService);

  status = signal<'loading' | 'error'>('loading');
  errorMessage = signal<string>('');

  ngOnInit(): void {
    // const code = this.route.snapshot.queryParamMap.get('code');
    // const state = this.route.snapshot.queryParamMap.get('state');

    // TikTok Marketing API may redirect with '?' encoded as '%3F' in the path,
    // producing no real query string. Decode the path to recover params.


    /**
     * http://localhost:4200/tiktok-business-callback
     * %3F
     * auth_code -> a0cc4636ca9a4190a9f95696030c560c0543ce44
     * &code -> a0cc4636ca9a4190a9f95696030c560c0543ce44
     * &state -> lit7c22nmzjm0fohclly8k
     */

    let searchString = window.location.search;
    if (!searchString) {
      const encodedQIndex = window.location.pathname.indexOf('%3F');
      if (encodedQIndex !== -1) {
        searchString = decodeURIComponent(window.location.pathname.substring(encodedQIndex));
      }
    }
    const urlParams = new URLSearchParams(searchString);
    // TikTok sends 'auth_code'; fall back to 'code' for compatibility
    const auth_code = urlParams.get('auth_code');
    const code =  urlParams.get('code');
    const state = urlParams.get('state');

    console.log('auth_code', auth_code);
    console.log('code', code);
    console.log('state', state);


    if (!code || !state) {
      this.errorMessage.set('Missing required parameters from TikTok callback.');
      this.status.set('error');
      return;
    }

    this.tiktokBusinessService.exchangeCode(code, state).subscribe({
      next: () => {
        this.router.navigate(['/my-brand', 'social-ads']);
      },
      error: (err: unknown) => {
        const message =
          err instanceof Error
            ? err.message
            : 'Failed to connect TikTok for Business account.';
        this.errorMessage.set(message);
        this.status.set('error');
      },
    });
  }
}
